import { useEffect } from "react";
import Testimonials from "../Home/Testimonials";
import * as Icons from "../common/Icons";
import DevelopmentStrategy from "./DevelopmentStrategy";
import DevelopmentObjectives from "./DevelopmentObjectives";

const WebDevelopment = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <div className="development-banner bg-center">
        <div className="w-full 2xl:container mx-auto lg:px-16 md:px-8 px-5 flex items-center h-full">
          <h1 className="font-montserrat lg:text-6xl md:text-5xl text-4xl font-semibold text-white">
            Web <br /> Development
          </h1>
        </div>
      </div>
      <div className="2xl:container mx-auto lg:px-16 md:px-8 px-5 py-16 xl:w-[85%] flex flex-col items-center">
        <p className="text-dark-green text-center font-raleway text-xl font-medium tracking-[6.6px]">
          Case Studies
        </p>
        <h2 className="font-raleway lg:text-4xl md:text-3xl text-2xl font-semibold text-white mt-5 text-center">
          Web Development
        </h2>
        <div className="mt-12 w-full">
          <h3 className="text-primary font-raleway md:text-4xl text-3xl font-semibold">
            Overview
          </h3>
          <p className="mt-5 text-white font-raleway md:text-xl text-lg">
            This case study delves into the transformative journey of a web
            development company that embraced cutting-edge methodologies,
            redefining traditional practices in the dynamic digital landscape.
            The evolution encompasses a holistic approach, incorporating diverse
            components such as web design, content creation, server-side
            scripting, network security configuration, and more.
          </p>
        </div>
      </div>
      <DevelopmentObjectives />
      <DevelopmentStrategy />
      <div className="it-service my-10">
        <div className="2xl:container mx-auto px-10 h-full flex items-center justify-center">
          <h3 className="text-white font-raleway lg:text-4xl sm:text-2xl text-xl font-semibold text-center">
            We run all kinds of{" "}
            <span className="text-primary">IT services</span> that vows your
            success
          </h3>
        </div>
      </div>
      <Testimonials />
    </>
  );
};

export default WebDevelopment;
